const foodrecipescomment = {
    add: 'foodrecipescomment/add-by-admin',
    getlist: 'foodrecipescomment/getlist-by-admin',
    update: 'foodrecipescomment/update',
    remove: 'foodrecipescomment/remove',
    get: 'foodrecipescomment/get',
}
export default foodrecipescomment
